import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../shared/services/authorization.service';

@Component({
  selector: 'app-auth-call-back',
  template: '',
  styles: [],
})
export class AuthCallBackComponent implements OnInit {
  public url?: string;

  constructor(
    private _authorization: AuthorizationService,
    private _router: Router,
  ) {}

  ngOnInit(): void {
    this._authorization
      .completeAuthentication()
      .then(() => {
        this.routerRedirect();
      })
      .catch((_err: any) => {
        this._router.navigate(['']);
      });
  }

  public routerRedirect(): void {
    if (this._authorization.getUrl()) {
      this._router.navigate([this._authorization.getUrl()?.path], {
        queryParams: this._authorization.getUrl()?.queryParams,
      });
    } else {
      this._router.navigate(['advisor']);
    }
  }
}
